import { actionKitImpFunction } from '../../../../../components/ozmoit/common';
import { getViewRequest, updateSessionRequest } from '../../create/api';
import { StudentRiskEvaluationSessionResponse } from '../../create/types';

const getViewDataAction = actionKitImpFunction(
  async (params: { id: string }) => {
    const response = await getViewRequest(params.id);
    if (response.error) {
      throw new Error('Error fetching form data');
    }
    return response.data;
  },
);

const updateSessionAction = actionKitImpFunction(
  async (data: StudentRiskEvaluationSessionResponse & { id: number }) => {
    const response = await updateSessionRequest(data);
    if (response.error) {
      throw new Error('Error saving session');
    }
    return response.data;
  },
);

export { getViewDataAction, updateSessionAction };
